import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Medkit = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="medkit icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0C7.067 0 5.5 1.567 5.5 3.5V6H2C0.895431 6 0 6.89543 0 8L0 22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V8C24 6.89543 23.1046 6 22 6H18.5V3.5C18.5 1.567 16.933 0 15 0L9 0ZM15.5 6V3.5C15.5 3.22386 15.2761 3 15 3H9C8.72386 3 8.5 3.22386 8.5 3.5V6H15.5ZM14 9H10V13H6V17H10V21H14V17H18V13H14V9Z"
    />
  </svg>
)
